import { motion } from 'motion/react';
import { ArrowRight, CheckCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

export const CTASection = () => {
  return (
    <section id="join" className="min-h-screen flex items-center justify-center py-20 relative overflow-hidden">
      <div className="absolute inset-0 bg-primary/5 skew-y-3 transform origin-top-left scale-110" />

      <div className="max-w-5xl mx-auto px-6 relative z-10 text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="bg-surface border border-primary/20 p-12 md:p-20 rounded-3xl shadow-2xl backdrop-blur-xl"
        >
          <h2 className="text-4xl md:text-6xl font-display font-bold text-text-main mb-8">
            PRZYGOTUJ SIĘ NA <span className="text-primary">TRANSFORMACJĘ</span>
          </h2>
          <p className="text-xl text-text-muted max-w-2xl mx-auto mb-12">
            Wybierz swoją Ścieżkę Kariery z AI. Przestań zgadywać, zacznij działać mądrze.
          </p>

          <div className="flex flex-col md:flex-row items-center justify-center gap-8 mb-12">
            {['Gotowe Schematy', 'Ścieżki Kariery AI', 'Społeczność Praktyków'].map((item) => (
              <div key={item} className="flex items-center gap-2 text-text-main font-medium">
                <CheckCircle className="text-primary w-5 h-5" />
                {item}
              </div>
            ))}
          </div>

          <Link to="/o-akademii" className="group px-8 py-4 bg-primary text-primary-foreground font-bold text-sm uppercase tracking-wider rounded-full hover:bg-primary/90 transition-all shadow-[0_0_30px_rgba(var(--color-primary),0.4)] flex items-center gap-2 mx-auto w-fit">
            Dopasuj Ścieżkę Kariery
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </Link>

          <p className="mt-6 text-xs text-text-muted font-mono uppercase tracking-wider">
            #MniejPracy #WięcejPieniędzy
          </p>
        </motion.div>
      </div>
    </section>
  );
};
